/**
 * useChatHistory — Hook de carga de historial de chat.
 *
 * V4: El chat inicia vacío en cada carga de página.
 * El contexto conversacional persiste solo mientras la página está abierta (Zustand/RAM).
 * El historial se sigue guardando en Redis para admin/analytics,
 * pero NO se restaura al UI al recargar.
 */
export function useChatHistory() {
  return { loadingHistory: false };
}
